// extracted by mini-css-extract-plugin
export var alerts = "headerSurvey-module--alerts--PYhq7";
export var brand = "headerSurvey-module--brand--lTS9e";
export var loginButton = "headerSurvey-module--login-button--vTCC7";
export var menuToggle = "headerSurvey-module--menu-toggle--AANRr";
export var mobileMenu = "headerSurvey-module--mobile-menu--1jFER";
export var mobileMenuOpen = "headerSurvey-module--mobile-menu-open--Oswdg";
export var navLinks = "headerSurvey-module--nav-links--NjRbj";
export var saveStyleButton = "headerSurvey-module--save-style-button--6ymDP";
export var surveyHeader = "headerSurvey-module--survey-header--YgHRi";
export var surveyLogo = "headerSurvey-module--survey-logo--XIXHI";